import api from '@/services/Api';
import Studie from '@/types/Studie';
import { successSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { StudienState, RootState } from '@/store/types';
import jspm from '@/services/PrintManager';

type Context = ActionContext<StudienState, RootState>;

export const studien: Module<StudienState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            studien: false,
            printers: false,
        },
        studien: [],
        printers: [],
    },
    actions: {
        loadStudien({ commit, rootState }: Context): void {
            commit('setLoadersStudien', true);

            api.post('verwaltung/studien/load')
                .then((response) => commit('setStudien', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersStudien', false));
        },
        updateStudie({ commit, dispatch }: Context, payload: Studie): void {
            commit('setLoadersSave', true);

            api.post('verwaltung/studien/speichern', payload)
                .then(() => {
                    successSwal('Studie', 'gespeichert');
                    dispatch('loadStudien');
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteStudie({ commit, dispatch }: Context, payload: Studie): void {
            commit('setLoadersDelete', true);

            api.post('verwaltung/studien/loeschen', payload)
                .then(() => {
                    successSwal('Studie', 'gelöscht');
                    dispatch('loadStudien');
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
        loadPrinters({ commit, dispatch }: Context): void {
            if (!jspm.printer?.hasConnected()) {
                dispatch('globals/setDialogDruckhinweis', true, { root: true });
                return;
            }

            const { JSPrintManager, WSStatus } = jspm.printer?.manager;

            if (JSPrintManager.websocket_status !== WSStatus.Open) {
                dispatch('globals/setDialogDruckhinweis', true, { root: true });
                return;
            }

            JSPrintManager
                .getPrinters()
                .then((printers: string[]) => commit('setPrinters', printers))
                .catch(console.error);
        },
    },
    mutations: {
        setStudien(state: StudienState, payload: Studie[]): void {
            state.studien = payload.map((data: Studie) => new Studie(data));
        },
        setDialogsDetail(state: StudienState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: StudienState, loading: boolean): void {
            state.loaders.save = loading;
        },
        setLoadersDelete(state: StudienState, loading: boolean): void {
            state.loaders.delete = loading;
        },
        setLoadersStudien(state: StudienState, loading: boolean): void {
            state.loaders.studien = loading;
        },
        setLoadersPrinters(state: StudienState, loading: boolean): void {
            state.loaders.printers = loading;
        },
        setPrinters(state: StudienState, printers: string[]): void {
            state.printers = printers;
        },
    },
};
